import { JsonpClientBackend } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AdminCtrlVehGeocerca } from 'src/app/models/admin-ctrlvehiculo-geocerca';
import { ControlVehiculosService } from 'src/app/services/admin/control-vehiculos-service/control-vehiculos.service';
import { ControlGeocercaService } from 'src/app/services/flota/control-geocerca-service/control-geocerca.service';
import { ControlRutasService } from 'src/app/services/flota/control-rutas-service/control-rutas.service';
import { ConfirmDialog } from 'src/app/shared/confirmdialog/confirmdialog.component';
import { Gtp } from 'src/app/shared/gtp';

@Component({
  selector: 'app-control-vehiculos-rutas-add',
  templateUrl: './control-vehiculos-rutas-add.component.html',
  styleUrls: ['./control-vehiculos-rutas-add.component.scss']
})
export class ControlVehiculosRutasAdd implements OnInit, OnDestroy {    
  
  loading:boolean = false;
  public contClass: string = 'container-fluid maincont';

  fechalang: any;

  //Listado de Geocercas
  public rutas = [];
  public rutasFiltered = [];
  //Listado de Fechas
  public dias = [];
  public diasFiltered = [];
  //Geocercas en perfil
  public rutasEnPerfil = [];
  
  public sendParams = null;
  public intervaloNotif = null;
  
  public invalidForm:boolean = true;
  
  public configPerfil = {
    control: {
      desde: null,
      hasta: null,
    },
    dia: null,
    ruta: null,
    intervaloNotif: 30,
    tiempoParada: 10,
    velMax: 80,
    avisofuera: true,
  };

  public perfilData = {
    geocercas: null,
    rangohoras: null,
    intervalonotif: null
  };

  public saveInterval;
  public defaultDate: Date;

  constructor(
    private gtp: Gtp,
    private dialog: MatDialog,
    private ctrlVehiculo: ControlVehiculosService,
    private ctrlRutas: ControlRutasService,
  ) {
    this.fechalang = this.gtp.fechalang;    
    
    this.configPerfil.control.desde = this.gtp.setHoras(0, 0, 0);    
    this.configPerfil.control.hasta = this.gtp.setHoras(0, 0, 0);    
    this.defaultDate = this.gtp.setHoras(0, 0, 0);    

    this.ctrlRutas.getRutas().subscribe(res => {
      this.rutas = res;
      this.rutasFiltered = res;
    });
    let dias = [
      {
        nro: 1,
        descr: 'Lunes'
      },
      {
        nro: 2,
        descr: 'Martes'
      },
      {
        nro: 3,
        descr: 'Miércoles'
      },
      {
        nro: 4,
        descr: 'Jueves'
      },
      {
        nro: 5,
        descr: 'Viernes'
      },
      {
        nro: 6,
        descr: 'Sábado'
      },
      {
        nro: 7,
        descr: 'Domingo'
      },
    ]
    this.dias = dias;
    this.diasFiltered = dias;

    this.ctrlRutas.callRutas();
  }
  
  ngOnInit(): void {
    // if (this.ctrlVehiculo.RutasConfig.length>0) {
    //   //this.setInitialInfo();
    // }
  }

  ngOnDestroy():void{
    
  }

  setInitialInfo(){    
    //Set Intervalo Notificaciones
    this.intervaloNotif = this.ctrlVehiculo.RutasConfig.intervalonotif;
    //Set Rango de Horas
    // this.rangohoras.lunes.desde.primero = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.lunes.desde.primero);   
    // this.rutasEnPerfil = this.ctrlVehiculo.geocercaConfig.geocercas;
  }

  formatRango(hora){
    let dia = this.gtp.getDay(new Date()).split('/');
    let fecha = `${dia[2]}/${dia[1]}/${dia[0]} ${hora}`;
    return this.gtp.String2Date(fecha);
  }

  /**
   * Cierra la ventana del informe activa.
   */
  cerrarInforme() {
    this.gtp.cerrarVentanas(true);
  }

  /**
   * Aumenta o disminuye el tamaño del ancho en el informe.
   */
  containerSize() {
    this.contClass = this.gtp.containerSize(this.contClass);
  }

  filterRuta(query) {
    let res = this.rutas.filter(s => (s.descripcion.toLocaleLowerCase().includes(query.toLocaleLowerCase())));
    this.rutasFiltered = (query == '') ? this.rutas : res;
  }

  filterDia(query) {
    let res = this.dias.filter(s => (s.dia.toLocaleLowerCase().includes(query.toLocaleLowerCase())));
    this.diasFiltered = (query == '') ? this.dias : res;
  }

  addRuta(ruta) {
    let res = this.rutasEnPerfil.filter(s => (s.cod_ruta == ruta.cod_ruta));    
    console.log(ruta);
    if (res.length==0) { 
      if(ruta.ruta) {
        this.rutasEnPerfil.push(ruta); 
      }
    }
  }
  
  removeRutas(id, pos){
    const dialogRef = this.dialog.open(ConfirmDialog, {
      width: this.gtp.confirmMinWidh,
      data: {
        value: id,
        titulo: 'BORRAR RUTA',
        descr: '¿Está seguro que querer eliminar el registro?',
        success_class: 'danger',
        success_text: 'Eliminar'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.rutasEnPerfil.splice(pos, 1);
      }
    });    
  }

  checkValidForm(){
    let error = false;
    if(
      !this.configPerfil.ruta ||                
      !this.configPerfil.dia
      //!this.configPerfil.intervaloNotif || 
      //!this.configPerfil.tiempoParada || 
      //!this.configPerfil.velMax ||
      //( this.gtp.getHourMinuteSecond(this.configPerfil.control.desde) == '00:00:00' && ( parseFloat(this.gtp.getMiliSeconds(this.configPerfil.control.desde))>0) ) ||
      //( this.gtp.getHourMinuteSecond(this.configPerfil.control.hasta) == '00:00:00' && ( parseFloat(this.gtp.getMiliSeconds(this.configPerfil.control.hasta))>0) )      
    ) {
      error = true;
    }
    this.invalidForm = error;
  }

  parseGeocercas(){
    var geo = [];
    this.rutasEnPerfil.forEach(el => {
      //el.maxparada = this.gtp.getDuration(el.maxparada);
      geo.push(el);
    });
    return geo;
  }

  //@ViewChild(MatSort, { static: true }) sort: dialogRef; 

  saveParams(){    
    console.log(this.sendParams);
  }

}
